import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import TaskOffCanvas from '../../../common/OffCanvas';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import ProjectAddUpdate from "./ProjectAddUpdate";
import CustomPagination from "../../../common/Pagination";
import moment from 'moment';
import { ShowToast } from '../../../common/Toastr';
import { ShowSwal, ShowSwalForCanvas, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { useTranslation } from 'react-i18next';
import Select, { StylesConfig } from 'react-select';
import { formatDateWithDateAndMonthName, getPageSizeArray, setItemStatus, paginationStyles, getFilteredList, sortData, getValueFromResource, FormatInvoiceDecimalNumber } from '../../../common/timeLiveFunction';
import clsx from 'clsx';
import parse from 'html-react-parser';
import { Dropdown } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../common/Loader';
import { getPagePermissionsAsync } from '../../../common/GlobalSlice';
import {
    getAccounyProjectList, GetAccountProjectPreferences, updatePagination, updateSearchPagination, updateAccountProjectId, updateIsLoading, updateProjectTemplateStatus,
    updateAccountProjectStatus, checkedAllState, unCheckedAllState, checkedState, unCheckedState, deleteSelectedAccountProjects, deleteAccountProject, updateIsTemplate,
    resetSelectedRecordObjectInState, updateSorting, updateMyProjectFilters, updateActiveFilter
} from "../projectSlice";
import fetchAPI from '../../../common/fetchAPI';
import { useDebounce } from '../../../_metronic/helpers';
import PageSizeSelect from '../../../common/PageSizeSelect';
import ProjectFilters from './ProjectFilter';
import { updateNextPage } from '../TasksSlice';
import { updateIsCanvasFrom } from '../MilestoneSlice';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle';

const initialValues = {
    IsTask: false,
    IsMilestone: false,
    IsProjectTeam: false,
    IsEditProjectTeam: false,
    IsMyProjectList: false,
    IsAllMyProject: false,
    IsAddMyProject: false,
    IsEditMyProject: false,
    permissionList: []
}

const initialValuesForProject = {
    isShowMyProject: false
}

const initialSortValues = {
    sortOrder: 'asc',
    sortColumn: 'ProjectName',
    columnList: []
}

const Project = () => {
    const { projectList, startRec, pageSize, pageNo, search, totalItems, isSearch, isLoading, isReload, isAllowPreferences, isTemplate, accountprojectid,
        orderDir, order, ProjectFilterValues, activeFilter, recordsFiltered
    } = useAppSelector((state) => state.project);
    const { nextPage } = useAppSelector((state) => state.tasks);
    const modelRef = useRef<any>(null);
    const projectsFilters: any = ProjectFilterValues
    const { cultureInfoName, pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, maxMenuHeight, sessionAccountEmployeeId, manageTerminologyList } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoadProjectFields, setLoadProjectFields] = useState(false);
    const [labelValues, setLabelValues] = useState<any[]>([]);
    const [myProjectList, setMyProjectList] = useState([]);
    // const [projectManage, setProjectManage] = useState(initialValuesForProject);
    const [childs, setChilds] = useState(initialValues);
    const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
    const [myPageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [clientArray, setClientArray] = useState([]);
    const [clientSideSorting, setClientSideSorting] = useState<any | ''>(initialSortValues);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [txtProjectCode, settxtProjectCode] = useState('');
     const [selectedEmployee, setSelectedEmployee] = useState<{ label: string; value: any } | null>(null);
    const [selectedClient, setSelectedClient] = useState<{ label: string; value: any } | null>(null);
    const [selectedStatus, setSelectedStatus] = useState<{ label: string; value: any } | null>(null);
    const [selectedCompleteStatus, setSelectedCompleteStatus] = useState<{ label: string; value: any }>({
        label: 'All',
        value: -1,
    });
    const [selectedActive, setSelectedActive] = useState<{ label: string; value: any } | null>(null);
    let pathName = location.pathname;
    // const [hoveredColumn, setHoveredColumn] = useState(null);
    let IsLicenseExpired = localStorage.getItem('IsLicenseExpired');
    // const { status, widgetFilters, fromDashboard } = location.state || {};
    const params = new URLSearchParams(location.search);
    const encoded = params.get("data");
    const parsedState = React.useMemo(() => {
        const encoded = params.get("data");
        return encoded ? JSON.parse(decodeURIComponent(encoded)) : {};
    }, [encoded]);
    const { widgetFilters = null, fromDashboard = false, status = null, IsOverdue = 0 } = parsedState;
    const [projectManage, setProjectManage] = useState({
        isShowMyProject: fromDashboard === true ? true : false
    });
    const [filterContext, setFilterContext] = useState<'list' | 'myProject'>('list');
    const filterContextRef = useRef<'list' | 'myProject'>('list');
    const isApplyingFilterRef = useRef(false);

    const updateFilterContext = (ctx: 'list' | 'myProject') => {
        setFilterContext(ctx);
        filterContextRef.current = ctx;
    };

    useEffect(() => {
        if (fromDashboard) {
            const mappedFilters: any = {
                AccountStatusId: status && Array.isArray(status) ? status.join(',') : '0',
                AccountProjectTypeId: 0,
                IncludeDateRange: 0,
                StartDate: '',
                EndDate: '',
                ProjectCode: '',
                AccountClientId: 0,
                AccountCompleteStatusId: -1,
            };

            if (widgetFilters) {
                mappedFilters.AccountProjectTypeId = widgetFilters.AccountProjectTypeId ? widgetFilters.AccountProjectTypeId[0] : 0;
                mappedFilters.AccountClientId = widgetFilters.AccountPartyId ? widgetFilters.AccountPartyId[0] : 0;
                mappedFilters.IncludeDateRange = widgetFilters.IncludeDateRange ? 1 : 0;

                if (widgetFilters.IncludeDateRange && widgetFilters.DateRange) {
                    mappedFilters.StartDate = widgetFilters.DateRange.startDate || '';
                    mappedFilters.EndDate = widgetFilters.DateRange.endDate || '';
                }
            }
            dispatch(updateMyProjectFilters(projectsFilters));
            dispatch(getAccounyProjectList(projectsFilters));
            // if (projectManage.isShowMyProject || !IsList) {
            renderMyProjectList();
            // }
        }
    }, [fromDashboard, widgetFilters, status, dispatch]);

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    //navigate('../error/403');
                }
                getCustomPagePermissionsAsync("32,30,88,27");
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        //navigate('../error/403');
                    }
                } else {
                    //navigate('../error/403');
                }
                getCustomPagePermissionsAsync("32,30,88,27");
            }
        }
        fetchPagePermissions();
        dispatch(updateIsTemplate(location.pathname.split('/').filter(Boolean)[0] === 'projects' ? false : true))
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const Clients = async () => {
        const response = await fetchAPI('api/V2/Clients/Active', "GET", "", true);
        const json = await response.json();
        setClientArray(json.Data);
    }
    useEffect(() => {
        Clients();
        if (IsList) {
            if (filterContextRef.current === 'myProject') return;
            if (isAllowPreferences) {
                dispatch(GetAccountProjectPreferences())
                    .then((result) => {
                        dispatch(getAccounyProjectList(projectsFilters))
                            .unwrap()
                            .then((originalPromiseResult) => {
                                setIsFirstTimeLoad(false);
                                // dispatch(updateNextPage(true));
                            })
                            .catch((rejectedValueOrSerializedError) => { })
                    })
                    .catch((error) => {
                    });
            } else {
                dispatch(getAccounyProjectList(projectsFilters))
                    .unwrap()
                    .then((result) => {
                        dispatch(updateNextPage(true));
                    })
                    .catch((error) => { })
            }
        } else if (childs.IsMyProjectList) {
            if (!IsList && childs.IsMyProjectList) {
                document.title = "My Projects | Livetecs";
            }
            if (isAllowPreferences) {
                dispatch(GetAccountProjectPreferences())
                    .then((result) => {
                        renderMyProjectList();
                    })
                    .catch((error) => {
                    });
            } else {
                renderMyProjectList();
            }
        }
    }, [pageNo, pageSize, isReload, IsList, childs.IsMyProjectList, orderDir, order, projectsFilters]);

    const myProjectHandleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    }

    const myProjectHandlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    }

    // const filteredData: any = getFilteredList(Object.values(myProjectList), searchTerm);
    // const indexOfLastItem = currentPage * myPageSize;
    // const indexOfFirstItem = indexOfLastItem - myPageSize;
    // let currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const myProjectTotalItems = Object.values(myProjectList).length;

    const filteredData: any = getFilteredList(Object.values(myProjectList), searchTerm);
    const indexOfLastItem = currentPage * myPageSize;
    const indexOfFirstItem = indexOfLastItem - myPageSize;
    //let currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    let currentItems = sortData(filteredData, clientSideSorting.sortOrder, clientSideSorting.sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const myProjectTotalItems = Object.values(myProjectList).length;

    const myProjectHandlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    }

    const getCustomPagePermissionsAsync = async (arg: string) => {
        const response = await fetchAPI('api/v2/PagePermission/GetCustomPagePermissions/?value=' + arg, 'Get', '', true);
        const json = await response.json();
        if (json.length > 0) {
            setChilds({
                ...childs,
                IsTask: json.filter((x: any) => x.Id === 32)[0].IsList,
                IsMilestone: json.filter((x: any) => x.Id === 30)[0].IsList,
                IsProjectTeam: json.filter((x: any) => x.Id === 88)[0].IsList,
                IsEditProjectTeam: json.filter((x: any) => x.Id === 88)[0].IsEdit,
                IsMyProjectList: json.filter((x: any) => x.Id === 27)[0].IsList,
                IsAllMyProject: json.filter((x: any) => x.Id === 27)[0].IsAll,
                IsAddMyProject: json.filter((x: any) => x.Id === 27)[0].IsAdd,
                IsEditMyProject: json.filter((x: any) => x.Id === 27)[0].IsEdit,
                permissionList: json
            });
            if (!json.filter((x: any) => x.Id === 27)[0].IsList && !IsList) {
                navigate('../error/403');
            }
        }
    }

    // const generalObject1 = {
    //     "name": t("Filters"),
    //     "width": "500px",
    //     "componentName": <ProjectFilters t={t} />
    // }

    const generalObject = {
        "name": t(
            isTemplate
                ? (accountprojectid === 0 ? getValueFromResource("Add Project Template", dispatch, t) : getValueFromResource("Update Project Template", dispatch, t))
                : (accountprojectid === 0 ? getValueFromResource('Add', dispatch, t) : getValueFromResource('Update', dispatch, t)) + ' ' + getValueFromResource('Project', dispatch, t)
        ),
        "width": "700px",
        "componentName": isLoadProjectFields && <ProjectAddUpdate IsLicenseExpired={IsLicenseExpired} />
    }

    // const generalObject = {
    //     "name": activeFilter === true
    //         ? t(
    //             isTemplate
    //                 ? (accountprojectid === 0 ? t("Add Project Template") : t("Update Project Template"))
    //                 : (accountprojectid === 0 ? t('Add') : t('Update')) + ' ' + t('Project')
    //         )
    //         : t("Filters"),
    //     "width": (activeFilter === true ? '700px' : '500px'), 
    //     "componentName": activeFilter === true
    //         ? (isLoadProjectFields && <ProjectAddUpdate />)
    //         : <ProjectFilters t={t} />
    // };

    const onFilterClick = (e: any) => {
        dispatch(updateActiveFilter(false))
        e.preventDefault();
    };

    const debouncedSearchTerm = useDebounce(search, 500);
    useEffect(() => {
        if (projectList.length > 0) {
            setIsFirstTimeLoad(false);
        }
        Clients();
        if (!isFirstTimeLoad) {
            if (filterContextRef.current === 'myProject') {
                return;
            }
            if (isAllowPreferences) {
                dispatch(GetAccountProjectPreferences())
                    .then((result) => {
                        dispatch(getAccounyProjectList(projectsFilters))
                        if (projectManage.isShowMyProject || !IsList) {
                            renderMyProjectList();
                        }
                    })
                    .catch((error) => {
                    });
            } else {
                dispatch(getAccounyProjectList(projectsFilters));
                if (projectManage.isShowMyProject || !IsList) {
                    renderMyProjectList();
                }
            }
        }
    }, [debouncedSearchTerm, projectsFilters]);

    useEffect(() => {
        if (isApplyingFilterRef.current) {
            isApplyingFilterRef.current = false;
            return;
        }
        if (projectManage.isShowMyProject || !IsList) {
            renderMyProjectList(ProjectFilterValues);
        }
    }, [ProjectFilterValues]);

    const onHandleSearch = (event: any) => {
        dispatch(updateSearchPagination(event.target.value));
    }

    const onHandlePageChange = (pageNumber: any) => {
        let objects = {
            "startRec": (pageNumber - 1) * Number(pageSize),
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        if (nextPage) {
            dispatch(updatePagination(objects));
            dispatch(updateNextPage(false))
        }
    }

    const onHandlePageSizeChange = (selectedOption: any) => {
        let objects = {
            "startRec": 0,
            "pageSize": selectedOption.value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const onHandleSorting = (orderDir: string, order: string) => {
        let objects = {
            "orderDir": orderDir,
            "order": order,
            "startRec": 0,
            "pageSize": pageSize,
            "pageNo": 1,
            "search": search
        }
        dispatch(updateSorting(objects));
    }

    const onHandleClientSideSorting = (orderDir: string, orderColumn: string) => {
        let arr: string[] = [...clientSideSorting.columnList];
        if (!arr.includes(orderColumn)) {
            arr.push(orderColumn);
        }
        setClientSideSorting({
            ...clientSideSorting,
            sortOrder: orderDir,
            sortColumn: orderColumn,
            columnList: arr
        });
        setPageSize(myPageSize);
        setCurrentPage(1);
    }

    const onAddProject = () => {
        dispatch(updateActiveFilter(true))
        if (clientArray.length > 0) {
            dispatch(resetSelectedRecordObjectInState());
            dispatch(updateProjectTemplateStatus(false));
            dispatch(updateAccountProjectId(0));
            setLoadProjectFields(true);
        } else {
            ShowSwalForCanvas('No Client found', "Please add Client before creating Project", "warning");
        }
    }

    const onEditProject = (id: number) => {
        dispatch(updateActiveFilter(true))
        dispatch(resetSelectedRecordObjectInState());
        dispatch(updateProjectTemplateStatus(false));
        dispatch(updateAccountProjectId(id));
        setLoadProjectFields(true);
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    }

    const onDeleteProject = (id: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(updateIsLoading(true));
                    dispatch(deleteAccountProject(id)).then((result) => {
                        Number(result.payload.Id) > 0 ?
                            ShowToast('Success', 'Project Delete Successfully!', "success", "toast-top-right") :
                            ShowToast('Error', 'Project Delete Failed!', "error", "toast-top-right");
                    }).catch((error) => {
                    })
                }
            })
            .catch((error) => {
            });
    }

    const onDeleteSelectedRecords = () => {
        let tempDeletedArray: any[] = [];
        projectList.map((item: any) => {
            if (item.isSelected == 1) {
                tempDeletedArray.push(item.AccountProjectId);
            }
        })
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(updateIsLoading(true));
                    dispatch(deleteSelectedAccountProjects(tempDeletedArray.toString()))
                        .unwrap()
                        .then((result) => {
                            result.StatusCode === "200" ?
                                ShowToast('Success', result.ResponseMessage, "success", "toast-top-right") :
                                ShowToast('Error', result.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((error) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    const onHandleChangeStatus = (e: any, accountProjectId: any) => {
        const { checked } = e.target;
        let Object = { 'IsDisabled': (checked ? true : false), 'AccountProjectId': accountProjectId }
        dispatch(updateIsLoading(true));
        dispatch(updateAccountProjectStatus(Object)).then((result) => {
            result.payload.hasOwnProperty('StatusCode') ?
                ShowToast('Success', result.payload.ResponseMessage, "success", "toast-top-right") :
                ShowToast('Error', 'Project Update Failed', "error", "toast-top-right");
        }).catch((rejectedValueOrSerializedError) => {
        })
    }

    const navigateToProjectTeam = (obj: any) => {
        // navigate('/projectteam', { state: { obj } })
        if (pathName === '/accountprojecttemplates') {
            navigate(`/projectteam/${obj.AccountProjectId}?from=templateToTeam`, { state: { obj } })
        } else {
            navigate(`/projectteam/${obj.AccountProjectId}`, { state: { obj } })
        }
    }

    const navigateToProjectSummary = (obj: any) => {
        //navigate('/accountprojectsummary', { state: { obj } });
        localStorage.setItem('objProject', JSON.stringify(obj));
        //setLocalStorageItem('objProject', obj);
        if (pathName === '/accountprojecttemplates') {
            navigate(`/accountprojectsummary/${obj.AccountProjectId}?from=projectTemplate`);
        } else {
            navigate(`/accountprojectsummary/${obj.AccountProjectId}`);
        }
    }

    const renderMyProjectList = async (overrideFilters?: any) => {
        let SearchParamsValues = `0,0,-1,0,'',0,0,0,'2026-04-09','2026-04-09',0`;

        // const ObjProjectFilters: any = ProjectFilterValues
        const ObjProjectFilters: any = overrideFilters || ProjectFilterValues;
        const {
            AccountEmployeeId,
            AccountClientId,
            AccountCompleteStatusId,
            AccountStatusId,
            ProjectCode,
            AccountProjectTypeId,
            IncludeDateRange,
            StartDate,
            EndDate,
            IsDisabled
        } = ObjProjectFilters;

        if (ProjectFilterValues) {
            if (fromDashboard && !(filterContextRef.current === 'myProject')) {
                const today = moment().format('YYYY-MM-DD');
                const dashboardStatus = status && Array.isArray(status) ? status.join(',') : (AccountStatusId ?? '0');
              
                const dashboardClientId = widgetFilters?.AccountPartyId ? widgetFilters.AccountPartyId[0] : AccountClientId;
                const dashboardProjectTypeId = widgetFilters?.AccountProjectTypeId ? widgetFilters.AccountProjectTypeId[0] : AccountProjectTypeId;
                const dashboardIncludeDateRange = widgetFilters?.IncludeDateRange ? 1 : 0;
                const dashboardStartDate = widgetFilters?.IncludeDateRange && widgetFilters?.DateRange?.startDate ? widgetFilters.DateRange.startDate : today;
                const dashboardEndDate = widgetFilters?.IncludeDateRange && widgetFilters?.DateRange?.endDate ? widgetFilters.DateRange.endDate : today;

                SearchParamsValues = `0,${dashboardClientId},${AccountCompleteStatusId},'${dashboardStatus}','${ProjectCode ?? ''}',-1,${dashboardProjectTypeId},${dashboardIncludeDateRange},'${dashboardStartDate}','${dashboardEndDate}',${IsOverdue}`;
            } else {
                SearchParamsValues = `${AccountEmployeeId},${AccountClientId},${AccountCompleteStatusId},'${AccountStatusId}',${ProjectCode},${IsDisabled},${AccountProjectTypeId},${IncludeDateRange ? 1 : 0},'${StartDate}','${EndDate}',0`;
            }
            // SearchParamsValues = `${AccountClientId},${AccountCompleteStatusId},'${AccountStatusId}',${ProjectCode},-1,${AccountProjectTypeId},${IncludeDateRange ? 1 : 0},'${StartDate}','${EndDate}'`;
        }

        const response = await fetchAPI(`api/v2/Projects/GetAssignedAccountProjects/${SearchParamsValues}/${sessionAccountEmployeeId}`, 'Get', '', true);
        const json = await response.json();
        if (json.length > 0) {
            if (json[0].Message && json[0].Message === 'No Data') {
                setMyProjectList([]);
            } else {
                setMyProjectList(json);
            }
        } else {
            setMyProjectList([]);
        }
        setProjectManage({
            ...projectManage,
            isShowMyProject: true
        })
        dispatch(updateIsLoading(false));
    }

    const myProjectListHandler = () => {
        if (myProjectList.length === 0) {
            dispatch(updateIsLoading(true));
            renderMyProjectList();
        } else {
            setProjectManage({
                ...projectManage,
                isShowMyProject: true
            })
        }
    }

    const navigateToAudit = (AccountProjectId: any) => {
        const obj = {
            Id: AccountProjectId,
            TableName: 'AccountProject',
            Title: getValueFromResource('Project Audit', dispatch, t)
        }
        navigate(`/accountaudit/${AccountProjectId}`, { state: { obj } })
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }


    const handleOnClickEvent = () => {
        setIsModalOpen(true);
    }
    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleApplyFilter = (filters: any) => {
        setIsModalOpen(false);
        isApplyingFilterRef.current = true;
        dispatch(updateMyProjectFilters(filters));
        if (filterContextRef.current === 'myProject' || projectManage.isShowMyProject || !IsList) {
            renderMyProjectList(filters);
        } else {
            dispatch(getAccounyProjectList(filters));
        }
    };

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                {/* {IsList &&
                    <> */}
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1">{(isTemplate ?
                        <>
                            {getValueFromResource('Project Templates List', dispatch, t)}
                            <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-project"
                                data-tooltip-content={getValueFromResource('Create and manage reusable project templates that preconfigure project details such as basic information, team members, approval workflows, billing settings, and other project options. Templates can be selected when creating new projects to ensure consistency and reduce manual setup.', dispatch, t)}
                            >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                            </div>
                        </>
                     :
                        (IsList && !projectManage.isShowMyProject) ? getValueFromResource('Project List', dispatch, t) : getValueFromResource('My Project List', dispatch, t))}</h3>
                    <div className="card-toolbar align-items-center">
                        {IsList && !isTemplate && <><div className="btn-toolbar justify-content-between" role="toolbar" aria-label="Toolbar with button groups">
                            <div className="btn-group" role="group" aria-label="First group">
                                {childs.IsMyProjectList && <button type="button"
                                    className={projectManage.isShowMyProject ? 'btn btn-outline btn-icon btn-light-primary btn-active-light-primary text-primary' : 'btn btn-outline btn-icon'}
                                    onClick={() => {
                                        myProjectListHandler()
                                    }}
                                    data-tooltip-id="tooltip-Description"
                                    data-tooltip-content=
                                    // {t("Just my projects")}
                                    {getValueFromResource("Just my projects", dispatch, t)}
                                    data-tooltip-place="bottom"
                                    style={{ height: 35, borderTopLeftRadius: 20, borderBottomLeftRadius: 20 }}>
                                    <i className="bi bi-person-fill fs-4"></i>
                                </button>}
                                <button
                                    type="button"
                                    className={!projectManage.isShowMyProject ? 'btn btn-outline btn-icon btn-light-primary btn-active-light-primary text-primary' : 'btn btn-outline btn-icon'}
                                    onClick={() => {
                                        setProjectManage({
                                            ...projectManage,
                                            isShowMyProject: false
                                        })
                                    }}
                                    data-tooltip-id="tooltip-Description"
                                    data-tooltip-content=
                                    // {t("Everyone's projects")}
                                    {getValueFromResource("Everyone's projects", dispatch, t)}
                                    data-tooltip-place="bottom"
                                    style={{ height: 35, borderTopRightRadius: 20, borderBottomRightRadius: 20 }}>
                                    <i className="bi bi-people-fill fs-4"></i>
                                </button>
                            </div>
                        </div>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        </>
                        }
                        {(!IsList || projectManage.isShowMyProject) ?
                            <>
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={myProjectHandleSearch}
                                        placeholder=
                                        // {t('Search')}
                                        {getValueFromResource('Search', dispatch, t)}
                                        className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"
                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center">
                                    {/* <Select
                                        styles={paginationStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        options={getPageSizeArray()}
                                        value={getPageSizeArray().find((option: any) => option.value == myPageSize)}
                                        onChange={myProjectHandlePageSizeChange}
                                        className='fs-7 fw-normal'
                                    /> */}
                                    <PageSizeSelect onChange={myProjectHandlePageSizeChange} />

                                </div>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    {(myProjectList.length > 0) ? (
                                        <CustomPagination
                                            currentPage={currentPage}
                                            onPageChange={myProjectHandlePageChange}
                                            pageSize={myPageSize}
                                            totalItems={myProjectTotalItems}
                                            start={(currentPage - 1) * myPageSize}
                                            t={t}
                                        >
                                        </CustomPagination>
                                    ) : null}
                                </div>

                                <div className='bullet bg-secondary h-35px w-1px mx-3'>
                                </div>

                                {/* <a
                                    id="kt_OffCanvas"
                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                    data-tooltip-id="tooltip-Description"
                                    data-tooltip-content={t("Filters")}
                                    data-tooltip-place="bottom"
                                    onClick={onFilterClick}>
                                    <i className="bi bi-filter fs-3 iconColor"></i>
                                </a> */}
                                <a
                                    ref={modelRef}
                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                    data-tooltip-id="tooltip-Description"
                                    data-tooltip-content={t("Filters")}
                                    data-tooltip-place="bottom"
                                    // onClick={handleOnClickEvent}
                                    onClick={() => {
                                        updateFilterContext('myProject');
                                        handleOnClickEvent();
                                    }}

                                >
                                    <i className="bi bi-filter fs-3 iconColor"></i>
                                </a>


                                {childs.IsAddMyProject && <><div className='h-35px w-1px mx-1'></div>

                                    <button
                                        id={(clientArray.length) > 0 ? "kt_OffCanvas" : ""}
                                        type="button"
                                        className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                        onClick={() => { onAddProject() }}
                                        disabled={IsLicenseExpired === "true" ? true : false}
                                    >
                                        {/* {t('Add Project')} */}
                                        {getValueFromResource('Add Project', dispatch, t)}
                                    </button>
                                </>}
                            </> :
                            <>
                                {IsList && <>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            value={search}
                                            onChange={onHandleSearch}
                                            placeholder=
                                            // {t('Search')}
                                            {getValueFromResource('Search', dispatch, t)}
                                            className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                            data-kt-user-table-filter="search"
                                        />
                                        <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </div>
                                    <div className='h-35px w-1px mx-1'></div>
                                    <div className="d-flex align-items-center">
                                        {/* <Select
                                            styles={paginationStyles}
                                            maxMenuHeight={maxMenuHeight}
                                            options={getPageSizeArray()}
                                            value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                            onChange={onHandlePageSizeChange}
                                            className='fs-7 fw-normal'
                                        /> */}
                                        <PageSizeSelect onChange={onHandlePageSizeChange} />

                                    </div>
                                    {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                    <div>
                                        {(projectList.length > 0) ? (
                                            <CustomPagination
                                                currentPage={pageNo}
                                                onPageChange={onHandlePageChange}
                                                pageSize={pageSize}
                                                totalItems={totalItems}
                                                start={startRec}
                                                t={t}
                                            >
                                            </CustomPagination>
                                        ) : null}
                                    </div> */}
                                    {(IsLicenseExpired === "false" && projectList.length > 0) && (
                                        <>
                                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                            <div>
                                                <CustomPagination
                                                    currentPage={pageNo}
                                                    onPageChange={onHandlePageChange}
                                                    pageSize={pageSize}
                                                    totalItems={totalItems}
                                                    start={startRec}
                                                    t={t}
                                                    recordsFiltered={recordsFiltered}
                                                />
                                            </div>
                                        </>
                                    )}

                                    <div className='bullet bg-secondary h-35px w-1px mx-3'>
                                    </div>

                                    {IsLicenseExpired === "false" && <a
                                        ref={modelRef}
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content={t("Filters")}
                                        data-tooltip-place="bottom"
                                        // onClick={handleOnClickEvent}
                                        onClick={() => {
                                            updateFilterContext('list');
                                            handleOnClickEvent();
                                        }}

                                    >
                                        <i className="bi bi-filter fs-3 iconColor"></i>
                                    </a>}

                                    {IsLicenseExpired === "false" && IsAdd && !isTemplate &&
                                        <>
                                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                            <div className="btn-group" style={{ display: projectList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}>
                                                <button
                                                    id={(clientArray.length) > 0 ? "kt_OffCanvas" : ""}
                                                    type="button"
                                                    className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                                    onClick={() => { onAddProject() }}
                                                >
                                                    {/* {t('Add Project')} */}
                                                    {getValueFromResource('Add Project', dispatch, t)}

                                                </button>
                                                <button type="button" className="btn btn-primary btn-bs-btn-font-weight btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i className="fa fa-angle-down"></i>
                                                </button>
                                                <ul className=" dropdown-menu menu-rounded px-1 py-1 fs-2" role="menu">
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            id={(clientArray.length) > 0 ? "kt_OffCanvas" : ""}
                                                            className="menu-item me-lg-0"
                                                            onClick={() => {
                                                                if (clientArray.length > 0) {
                                                                    dispatch(updateProjectTemplateStatus(true));
                                                                    setLoadProjectFields(true);
                                                                    dispatch(updateActiveFilter(true));
                                                                } else {
                                                                    ShowSwalForCanvas('No Client found', "Please add Client before creating Project", "warning");
                                                                }
                                                            }}
                                                        >
                                                            <span className="menu-icon custom-menu mb-2">
                                                                <i className="bi bi-file-earmark-text fs-6 iconColor">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize" style={{ paddingRight: 6 }}>
                                                                {/* {`${t('Add Project From Template')}`} */}
                                                                {getValueFromResource('Add Project From Template', dispatch, t)}
                                                            </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </ul>
                                            </div>
                                        </>
                                    }
                                </>}
                                {isTemplate &&
                                    <>
                                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                        <button
                                            id="kt_OffCanvas"
                                            type="button"
                                            className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                            onClick={() => { onAddProject() }}
                                        >
                                            {/* {t('Add Project Template')} */}
                                            {getValueFromResource('Add Project Template', dispatch, t)}
                                        </button>
                                    </>
                                }
                                <>
                                    <div className="text-muted me-5" style={{ marginRight: '2px', display: projectList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                        <span className="me-2" data-kt-user-table-select="selected_count">{projectList.filter((item: any) => item.isSelected === 1).length}</span>
                                        {/* {t('Selected')} */}
                                        {getValueFromResource('Selected', dispatch, t)}
                                    </div>
                                    {IsDelete && <button type="button" className="btn btn-danger btn-sm"
                                        onClick={() => { onDeleteSelectedRecords() }}
                                        style={{ marginRight: '2px', display: projectList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                    >
                                        <i className="bi bi-trash fs-5 me-2"></i>
                                        {/* {t('Delete')} */}
                                        {getValueFromResource('Delete', dispatch, t)}
                                    </button>
                                    }
                                </>
                            </>
                        }
                    </div>
                </div>
                {/* <div className='card-body py-3'> */}
                <div className='card-Report-body py-3'>
                    <div className='table-responsive'>
                        {(!IsList || projectManage.isShowMyProject) ?
                            <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                                <thead>
                                    <tr className='thHeading align-middle'>
                                        {/* className='min-w-100px' */}
                                        <th style={{ width: '10%' }}
                                        // onMouseEnter={() => handleMouseEnter(0)}
                                        // onMouseLeave={handleMouseLeave}
                                        >
                                            {/* {t("Active / InActive")} */}
                                            {getValueFromResource('Active / Inactive', dispatch, t)}
                                            {clientSideSorting.sortColumn === 'IsDisabled' ?
                                                clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                                    {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                                    {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                </span>
                                                :
                                                // hoveredColumn === 0 && 
                                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </>}
                                        </th>
                                        <th style={{ width: '15%' }}
                                        // onMouseEnter={() => handleMouseEnter(1)}
                                        // onMouseLeave={handleMouseLeave}
                                        >
                                            {/* {t("Code")} */}
                                            {getValueFromResource('Code', dispatch, t)}
                                            {clientSideSorting.sortColumn === 'ProjectCode' ?
                                                clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectCode") }}>
                                                    {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectCode") }}>
                                                    {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                </span>
                                                :
                                                // hoveredColumn === 1 && 
                                                <><span className='cursor' onClick={() => { onHandleClientSideSorting("asc", "ProjectCode") }}>
                                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                    <span className='cursor' onClick={() => { onHandleClientSideSorting("desc", "ProjectCode") }}>
                                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </>}
                                        </th>
                                        <th style={{ width: '30%' }}
                                        // onMouseEnter={() => handleMouseEnter(2)}
                                        // onMouseLeave={handleMouseLeave}
                                        >
                                            {getValueFromResource('Project Name', dispatch, t)}
                                            {/* (Object.values(clientSideSorting.columnList).includes('ProjectName')) ? */}
                                            {clientSideSorting.sortColumn === 'ProjectName' ?
                                                clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                                    {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                                    {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                </span>
                                                :
                                                // hoveredColumn === 2 && 
                                                <><span className='cursor' onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                    <span className='cursor' onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </>}
                                        </th>
                                        <th style={{ width: '15%' }}
                                        // onMouseEnter={() => handleMouseEnter(3)}
                                        // onMouseLeave={handleMouseLeave}
                                        >
                                            {getValueFromResource('Client Name', dispatch, t)}
                                            {clientSideSorting.sortColumn === 'ClientName' ?
                                                clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ClientName") }}>
                                                    {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ClientName") }}>
                                                    {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                </span>
                                                :
                                                // hoveredColumn === 3 && 
                                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ClientName") }}>
                                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ClientName") }}>
                                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </>}
                                            {/* {hoveredColumn === 3 && (<><span className="menu-icon custom-menu mb-2" onClick={() => { onHandleClientSideSorting("asc", "ClientName") }}>
                                                <i className="bi bi-sort-up fs-6 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleClientSideSorting("desc", "ClientName") }}>
                                                    <i className="bi bi-sort-down fs-4 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span></>)} */}
                                        </th>
                                        <th style={{ width: '15%' }}
                                        // onMouseEnter={() => handleMouseEnter(4)}
                                        // onMouseLeave={handleMouseLeave}
                                        >
                                            {/* {t("Status")} */}
                                            {getValueFromResource('Status', dispatch, t)}
                                            {clientSideSorting.sortColumn === 'Status' ?
                                                clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Status") }}>
                                                    {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Status") }}>
                                                    {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                </span>
                                                :
                                                // hoveredColumn === 4 && 
                                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Status") }}>
                                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Status") }}>
                                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </>}
                                        </th>
                                        <th
                                            //className='min-w-100px text-center'
                                            style={{ width: '15%' }}
                                        >
                                            {/* {t("Allocation Hours")} */}
                                            {getValueFromResource('Allocation Hours', dispatch, t)}
                                            {clientSideSorting.sortColumn === 'AllocationHours' ?
                                                clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AllocationHours") }}>
                                                    {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AllocationHours") }}>
                                                    {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> */}
                                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                </span>
                                                :
                                                // hoveredColumn === 4 && 
                                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AllocationHours") }}>
                                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AllocationHours") }}>
                                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </>}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.length > 0 && currentItems.map((item: any) => {
                                        return (
                                            <tr key={item.AccountProjectId}>
                                                <td>
                                                    <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled === false ? "Active" : "InActive"))}>
                                                        {item.IsDisabled === false ? "Active" : "InActive"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <a className='text-gray-800 d-block'>
                                                        {item.ProjectPrefix && item.ProjectPrefix.trim() !== ''
                                                            ? `${item.ProjectPrefix}-${item.ProjectCode}`
                                                            : item.ProjectCode
                                                        }
                                                    </a>
                                                </td>
                                                <td>
                                                    <a className='text-dark fw-bold d-block cursor'
                                                        onClick={() => {
                                                            childs.IsEditMyProject && navigateToProjectSummary({
                                                                "AccountProjectId": item.AccountProjectId,
                                                                "ProjectCode": item.ProjectCode,
                                                                "ProjectName": item.ProjectName,
                                                                "Status": item.Status,
                                                                "StartDate": item.StartDate,
                                                                "Deadline": item.Deadline,
                                                                "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                "IsSummaryFrom": 'View',
                                                                "IsTask": childs.IsTask,
                                                                "IsMilestone": childs.IsMilestone,
                                                                "IsProjectTeam": childs.IsProjectTeam
                                                            });
                                                        }}
                                                    >
                                                        {item.ProjectName}
                                                    </a>
                                                    <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                                        {/* {`${moment.parseZone(item.StartDate).format('DD MMM yy')} - ${moment.parseZone(item.Deadline).format('DD MMM yy')}`} */}
                                                        {formatDateWithDateAndMonthName(item.StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(item.Deadline, cultureInfoName.toString())}
                                                    </span>
                                                </td>
                                                <td>
                                                    <a className='text-gray-800 d-block'>
                                                        {item.ClientName}
                                                    </a>
                                                </td>
                                                <td>
                                                    <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.Status))}>
                                                        {item.Status}
                                                    </span>
                                                </td>
                                                <td >
                                                    <a className='text-gray-800 d-block'>

                                                        {/* {item.AllocationHours.toFixed(2)} */}

                                                        {item.AllocationHours !== undefined ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.AllocationHours, 2) : ''}
                                                    </a>
                                                </td>
                                                <td className='text-center'>
                                                    <Dropdown
                                                        style={{ marginLeft: 1 }}
                                                        className={clsx('cursor-pointer symbol')}
                                                        data-kt-menu-attach='parent'
                                                        data-kt-menu-placement='bottom-end'
                                                    >
                                                        <Dropdown.Toggle
                                                            variant="transparent"
                                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                            data-tooltip-id="tooltip-Description"
                                                            data-tooltip-content=
                                                            // {t("More")}
                                                            {getValueFromResource('More', dispatch, t)}
                                                            data-tooltip-place="top"
                                                        >
                                                            <i className="bi bi-three-dots fs-7"></i>
                                                        </Dropdown.Toggle>
                                                        {(childs.IsAllMyProject || childs.IsEditMyProject) && <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0"
                                                                    onClick={() => {
                                                                        navigateToProjectSummary({
                                                                            "AccountProjectId": item.AccountProjectId,
                                                                            "ProjectCode": item.ProjectCode,
                                                                            "ProjectName": item.ProjectName,
                                                                            "Status": item.Status,
                                                                            "StartDate": item.StartDate,
                                                                            "Deadline": item.Deadline,
                                                                            "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                            "IsSummaryFrom": 'View',
                                                                            "IsTask": childs.IsTask,
                                                                            "IsMilestone": childs.IsMilestone,
                                                                            "IsProjectTeam": childs.IsProjectTeam
                                                                        });
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        {/* <i className="bi bi-file-earmark-text fs-4 iconColor">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i> */}
                                                                        <i className="bi bi-box-arrow-up-right fs-6 iconColor">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {getValueFromResource('View Project', dispatch, t)}
                                                                    </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                            {childs.IsTask && <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0"
                                                                    onClick={() => {
                                                                        navigateToProjectSummary({
                                                                            "AccountProjectId": item.AccountProjectId,
                                                                            "ProjectCode": item.ProjectCode,
                                                                            "ProjectName": item.ProjectName,
                                                                            "Status": item.Status,
                                                                            "StartDate": item.StartDate,
                                                                            "Deadline": item.Deadline,
                                                                            "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                            "IsSummaryFrom": 'Task',
                                                                            "IsTask": childs.IsTask,
                                                                            "IsMilestone": childs.IsMilestone,
                                                                            "IsProjectTeam": childs.IsProjectTeam
                                                                        });
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        <i className="bi bi-file-earmark-text fs-4 iconColor">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {labelValues[7] && labelValues[7]["Task"]} */}
                                                                        {getValueFromResource('Task', dispatch, t)}

                                                                    </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                            }
                                                            {childs.IsProjectTeam && <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0"
                                                                    onClick={() => {
                                                                        navigateToProjectTeam({
                                                                            "AccountProjectId": item.AccountProjectId,
                                                                            "ProjectCode": item.ProjectCode,
                                                                            "ProjectName": item.ProjectName,
                                                                            "Status": item.Status,
                                                                            "StartDate": item.StartDate,
                                                                            "Deadline": item.Deadline,
                                                                            "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                            "IsEditProjectTeam": childs.IsEditProjectTeam
                                                                        })
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        <i className="bi bi-person-plus fs-4 iconColor">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {getValueFromResource('Team', dispatch, t)}

                                                                    </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                            }
                                                            {childs.IsMilestone && <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0"
                                                                    onClick={() => {
                                                                        navigateToProjectSummary({
                                                                            "AccountProjectId": item.AccountProjectId,
                                                                            "ProjectCode": item.ProjectCode,
                                                                            "ProjectName": item.ProjectName,
                                                                            "Status": item.Status,
                                                                            "StartDate": item.StartDate,
                                                                            "Deadline": item.Deadline,
                                                                            "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                            "IsSummaryFrom": 'Milestone',
                                                                            "IsTask": childs.IsTask,
                                                                            "IsMilestone": childs.IsMilestone,
                                                                            "IsProjectTeam": childs.IsProjectTeam
                                                                        });
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        {/* <i className="bi bi-file-earmark-text fs-6 iconColor">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i> */}
                                                                           <i className="bi bi-flag fs-6 iconColor">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {getValueFromResource('Milestone', dispatch, t)}
                                                                    </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                            }
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => navigateToAudit(item.AccountProjectId)}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-receipt fs-6 iconColor">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {labelValues[10] && labelValues[10]["Audit"]} */}
                                                                    {getValueFromResource('Audit', dispatch, t)}

                                                                </span>
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>}
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table> : <>
                                {IsList && <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                                    <thead>
                                        <tr className='thHeading align-middle'>
                                            {IsDelete &&
                                                <th className='w-25px'>
                                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                        <input
                                                            className='form-check-input'
                                                            type='checkbox'
                                                            checked={projectList.every((item: any) => item.isSelected === 0) ? false :
                                                                (projectList.every((item: any) => item.isSelected === 1 ? true : false))
                                                            }
                                                            onChange={handleSelectAllChange}
                                                        />
                                                    </div>
                                                </th>
                                            }
                                            {IsEdit &&
                                                <th style={{ width: '10%' }}
                                                // onMouseEnter={() => handleMouseEnter(1)}
                                                // onMouseLeave={handleMouseLeave}
                                                >
                                                    {/* {t("Active / InActive")} */}
                                                    {getValueFromResource('Active / Inactive', dispatch, t)}

                                                    {order === '1' ?
                                                        orderDir === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                            {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i> */}
                                                            <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                            {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i> */}
                                                            <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                        </span>
                                                        :
                                                        // hoveredColumn === 1 && 
                                                        <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                            <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                            <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                                <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                        </>}
                                                    {/* <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("asc", "1") }}>
                                                        <i className="bi bi-sort-up fs-6 iconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("desc", "1") }}>
                                                        <i className="bi bi-sort-down fs-4 iconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span> */}
                                                </th>
                                            }
                                            <th style={{ width: '15%' }}
                                            // onMouseEnter={() => handleMouseEnter(3)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Code")} */}
                                                {getValueFromResource('Code', dispatch, t)}
                                                {order === '3' ?
                                                    orderDir === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                        {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i> */}
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                        {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i> */}
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 3 && 
                                                    <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                                {/* <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("asc", "3") }}>
                                                    <i className="bi bi-sort-up fs-6 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("desc", "3") }}>
                                                    <i className="bi bi-sort-down fs-4 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span> */}
                                            </th>
                                            <th style={{ width: '30%' }}
                                            // onMouseEnter={() => handleMouseEnter(4)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Project Name")} */}
                                                {getValueFromResource('Project Name', dispatch, t)}
                                                {order === '4' ?
                                                    orderDir === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                                        {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i> */}
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                                        {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i> */}
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 4 && 
                                                    <><span className="cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                                {/* <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("asc", "4") }}>
                                                    <i className="bi bi-sort-up fs-6 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("desc", "4") }}>
                                                    <i className="bi bi-sort-down fs-4 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span> */}
                                            </th>
                                            <th style={{ width: '15%' }}
                                            // onMouseEnter={() => handleMouseEnter(5)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Client Name")} */}
                                                {getValueFromResource('Client Name', dispatch, t)}
                                                {order === '5' ?
                                                    orderDir === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                                        {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i> */}
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                                        {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i> */}
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 5 && 
                                                    <><span className="cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                                {/* <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("asc", "5") }}>
                                                <i className="bi bi-sort-up fs-6 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("desc", "5") }}>
                                                    <i className="bi bi-sort-down fs-4 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span> */}
                                            </th>
                                            <th style={{ width: '10%' }}
                                            // onMouseEnter={() => handleMouseEnter(6)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Status")} */}
                                                {getValueFromResource('Status', dispatch, t)}
                                                {order === '6' ?
                                                    orderDir === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                                        {/* <i className="bi bi-arrow-up fs-7 sortIconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i> */}
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                                        {/* <i className="bi bi-arrow-down fs-7 sortIconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i> */}
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 6 && 
                                                    <><span className="cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                                {/* <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("asc", "6") }}>
                                                <i className="bi bi-sort-up fs-6 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="menu-icon custom-menu mb-2" onClick={() => { onHandleSorting("desc", "6") }}>
                                                    <i className="bi bi-sort-down fs-4 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span> */}
                                            </th>
                                            <th style={{ width: '20%' }}>
                                                {/* {t("Team")} */}
                                                {getValueFromResource('Team', dispatch, t)}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {projectList.length > 0 && projectList.map((item) => {
                                            return (
                                                <tr key={item.AccountProjectId}>
                                                    {IsDelete &&
                                                        <td>
                                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                                <input
                                                                    className='form-check-input widget-9-check'
                                                                    type='checkbox'
                                                                    checked={item.isSelected == 0 ? false : true}
                                                                    onChange={(e) => { handleCheckboxChange(e, item.AccountProjectId) }}
                                                                />
                                                            </div>
                                                        </td>
                                                    }
                                                    {IsEdit &&
                                                        <td className='text-center'>
                                                            <div className="form-check form-switch form-check-custom">
                                                                {/* <input
                                                                    type="checkbox"
                                                                    className="form-check-input custom-padding-right h-15px w-30px"
                                                                    checked={item.IsDisabled == true ? true : false}
                                                                    onChange={(e) => { onHandleChangeStatus(e, item.AccountProjectId) }}
                                                                /> */}
                                                                <td>
                                                                    <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled === false ? "Active" : "InActive"))}>
                                                                        {item.IsDisabled === false ? "Active" : "InActive"}
                                                                    </span>
                                                                </td>
                                                            </div>
                                                        </td>
                                                    }
                                                    <td>
                                                        <a className='text-gray-800 d-block'>
                                                            {item.ProjectCode}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <a
                                                            className='text-dark fw-bold d-block cursor'
                                                            onClick={() => {
                                                                dispatch(updateIsCanvasFrom('Task'));
                                                                navigateToProjectSummary({
                                                                    "AccountProjectId": item.AccountProjectId,
                                                                    "ProjectCode": item.ProjectCode,
                                                                    "ProjectName": item.ProjectName,
                                                                    "Status": item.Status,
                                                                    "StartDate": item.StartDate,
                                                                    "Deadline": item.Deadline,
                                                                    "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                    "IsSummaryFrom": 'View',
                                                                    "IsTask": childs.IsTask,
                                                                    "IsMilestone": childs.IsMilestone,
                                                                    "IsProjectTeam": childs.IsProjectTeam
                                                                    // "ChildPermission": childs.permissionList
                                                                });
                                                            }}
                                                        >
                                                            {item.ProjectName}
                                                        </a>
                                                        <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                                            {/* {`${moment.parseZone(item.StartDate).format('DD MMM yy')} - ${moment.parseZone(item.Deadline).format('DD MMM yy')}`} */}
                                                            {formatDateWithDateAndMonthName(item.StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(item.Deadline, cultureInfoName.toString())}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <a className='text-gray-800 d-block'>
                                                            {item.AccountClientName}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.Status))}>
                                                            {item.Status}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                                            <div className='d-flex align-items-center flex-shrink-0 me-5'>
                                                                <div className='symbol-group symbol-hover flex-shrink-0 me-2'>
                                                                    {item.TeamMembers != null && parse(`${item.TeamMembers}`)}
                                                                </div>
                                                            </div>
                                                        </span>
                                                    </td>
                                                    <td className='text-center'>
                                                        <Dropdown
                                                            style={{ marginLeft: 1 }}
                                                            className={clsx('cursor-pointer symbol')}
                                                            data-kt-menu-attach='parent'
                                                            data-kt-menu-placement='bottom-end'
                                                        >
                                                            <Dropdown.Toggle
                                                                variant="transparent"
                                                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                                data-tooltip-id="tooltip-Description"
                                                                data-tooltip-content=
                                                                // {t("More")}
                                                                {getValueFromResource('More', dispatch, t)}
                                                                data-tooltip-place="top"
                                                            >
                                                                <i className="bi bi-three-dots fs-7"></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                                {IsEdit && <div className='menu-hover-bg-sec'>
                                                                    <Dropdown.Item
                                                                        id="kt_OffCanvas"
                                                                        className="menu-item me-lg-0"
                                                                        onClick={() => { onEditProject(item.AccountProjectId) }}
                                                                    >
                                                                        <span className="menu-icon custom-menu mb-2">
                                                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                        <span className="menu-title custom-menu-fontsize">
                                                                            {/* {`${t('Edit')}`} */}
                                                                            {getValueFromResource('Edit', dispatch, t)}
                                                                        </span>
                                                                    </Dropdown.Item>
                                                                </div>}
                                                                <div className='menu-hover-bg-sec'>
                                                                    <Dropdown.Item
                                                                        className="menu-item me-lg-0"
                                                                        onClick={() => {
                                                                            navigateToProjectSummary({
                                                                                "AccountProjectId": item.AccountProjectId,
                                                                                "ProjectCode": item.ProjectCode,
                                                                                "ProjectName": item.ProjectName,
                                                                                "Status": item.Status,
                                                                                "StartDate": item.StartDate,
                                                                                "Deadline": item.Deadline,
                                                                                "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                                "IsSummaryFrom": 'View',
                                                                                "IsTask": childs.IsTask,
                                                                                "IsMilestone": childs.IsMilestone,
                                                                                "IsProjectTeam": childs.IsProjectTeam
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span className="menu-icon custom-menu mb-2">
                                                                            <i className="bi bi-box-arrow-up-right fs-6 iconColor">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                            {/* <i className="bi bi-file-earmark-text fs-4 iconColor">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i> */}
                                                                        </span>
                                                                        <span className="menu-title custom-menu-fontsize">
                                                                            {/* {`${t('View Project')}`} */}
                                                                            {getValueFromResource('View Project', dispatch, t)}
                                                                        </span>
                                                                    </Dropdown.Item>
                                                                </div>
                                                                {childs.IsTask && <div className='menu-hover-bg-sec'>
                                                                    <Dropdown.Item
                                                                        className="menu-item me-lg-0"
                                                                        onClick={() => {
                                                                            navigateToProjectSummary({
                                                                                "AccountProjectId": item.AccountProjectId,
                                                                                "ProjectCode": item.ProjectCode,
                                                                                "ProjectName": item.ProjectName,
                                                                                "Status": item.Status,
                                                                                "StartDate": item.StartDate,
                                                                                "Deadline": item.Deadline,
                                                                                "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                                "IsSummaryFrom": 'Task',
                                                                                "IsTask": childs.IsTask,
                                                                                "IsMilestone": childs.IsMilestone,
                                                                                "IsProjectTeam": childs.IsProjectTeam
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span className="menu-icon custom-menu mb-2">
                                                                            <i className="bi bi-file-earmark-text fs-4 iconColor">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                        <span className="menu-title custom-menu-fontsize">
                                                                            {/* {`${t('Task')}`} */}
                                                                            {getValueFromResource('Task', dispatch, t)}
                                                                        </span>
                                                                    </Dropdown.Item>
                                                                </div>
                                                                }
                                                                {childs.IsProjectTeam && <div className='menu-hover-bg-sec'>
                                                                    <Dropdown.Item
                                                                        className="menu-item me-lg-0"
                                                                        onClick={() => {
                                                                            navigateToProjectTeam({
                                                                                "AccountProjectId": item.AccountProjectId,
                                                                                "ProjectCode": item.ProjectCode,
                                                                                "ProjectName": item.ProjectName,
                                                                                "Status": item.Status,
                                                                                "StartDate": item.StartDate,
                                                                                "Deadline": item.Deadline,
                                                                                "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                                "IsEditProjectTeam": childs.IsEditProjectTeam
                                                                            })
                                                                        }}
                                                                    >
                                                                        <span className="menu-icon custom-menu mb-2">
                                                                            <i className="bi bi-person-plus fs-4 iconColor">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                        <span className="menu-title custom-menu-fontsize">
                                                                            {/* {`${t('Team')}`} */}
                                                                            {getValueFromResource('Team', dispatch, t)}
                                                                        </span>
                                                                    </Dropdown.Item>
                                                                </div>
                                                                }
                                                                {childs.IsMilestone && <div className='menu-hover-bg-sec'>
                                                                    <Dropdown.Item
                                                                        className="menu-item me-lg-0"
                                                                        onClick={() => {
                                                                            navigateToProjectSummary({
                                                                                "AccountProjectId": item.AccountProjectId,
                                                                                "ProjectCode": item.ProjectCode,
                                                                                "ProjectName": item.ProjectName,
                                                                                "Status": item.Status,
                                                                                "StartDate": item.StartDate,
                                                                                "Deadline": item.Deadline,
                                                                                "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                                                                "IsSummaryFrom": 'Milestone',
                                                                                "IsTask": childs.IsTask,
                                                                                "IsMilestone": childs.IsMilestone,
                                                                                "IsProjectTeam": childs.IsProjectTeam
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span className="menu-icon custom-menu mb-2">
                                                                            <i className="bi bi-flag fs-6 iconColor">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                            {/* <i className="bi bi-file-earmark-text fs-6 iconColor">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i> */}
                                                                        </span>
                                                                        <span className="menu-title custom-menu-fontsize">
                                                                            {/* {`${t('Milestone')}`} */}
                                                                            {getValueFromResource('Milestone', dispatch, t)}
                                                                        </span>
                                                                    </Dropdown.Item>
                                                                </div>
                                                                }
                                                                {pathName !== '/accountprojecttemplates' && <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => navigateToAudit(item.AccountProjectId)}
                                                                >
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        <i className="bi bi-receipt fs-6 iconColor">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Audit')}`} */}
                                                                        {getValueFromResource('Audit', dispatch, t)}
                                                                    </span>
                                                                </Dropdown.Item>}

                                                                {IsDelete && <><div className='separator mb-1 mt-1 opacity-75'></div>
                                                                    <div className='menu-hover-bg-danger'>
                                                                        <Dropdown.Item
                                                                            className="menu-item me-lg-0"
                                                                            onClick={() => { onDeleteProject(item.AccountProjectId) }}
                                                                        >
                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                            <span className="menu-title delete-menu custom-menu-fontsize">
                                                                                {/* {`${t('Delete')}`} */}
                                                                                {getValueFromResource('Delete', dispatch, t)}
                                                                            </span>
                                                                        </Dropdown.Item>
                                                                    </div>
                                                                </>}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>} </>
                        }
                        {IsList && projectList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found', dispatch, t)}
                                </p>
                            </div>
                        }

                        {projectManage.isShowMyProject && myProjectList.length === 0 && projectList.length !== 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found', dispatch, t)}

                                </p>
                            </div>
                        }
                    </div>
                </div>
                {/* </>
                } */}
            </div>

            {<TaskOffCanvas obj={generalObject} />}
            {isModalOpen &&
                <ProjectFilters txtProjectCode={txtProjectCode}
                    settxtProjectCode={settxtProjectCode}
                    selectedEmployee={selectedEmployee}
                    setSelectedEmployee={setSelectedEmployee}
                    selectedClient={selectedClient}
                    setSelectedClient={setSelectedClient}
                    selectedStatus={selectedStatus}
                    setSelectedStatus={setSelectedStatus}
                    selectedCompleteStatus={selectedCompleteStatus}
                    setSelectedCompleteStatus={setSelectedCompleteStatus}
                    selectedActive={selectedActive}
                    setSelectedActive={setSelectedActive}
                    onApplyFilter={handleApplyFilter} modelRef={modelRef} t={t} oncloseModal={closeModal} />
            }
            <ReactTooltip
                id="tooltip-project"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}

export default Project